export default __webpack_public_path__ + "static/media/date-add.c7812a71.svg";